export const StartingPage = {
    Title: 'Learn how to become a Curb-it hauler.',
    Buttons: {
        SignIn: {
            label: 'Sign In'
        }
    }
}



// WEBPACK FOOTER //
// ./src/localization/StartingPage.ts